<template>
  <div class="emd-panel">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'EmdPanel',
  props: {
    title: {
      type: String,
      required: false
    },
    description: {
      type: String,
      required: false
    },
    sections: {
      type: Number,
      default: 1,
      required: false
    }
  }
}
</script>
